import apiService from './ApiService';

export default class BroadcastEmailApiService {
    /**
     * Get the number of active subscribers who would receive a broadcast email
     * @returns {Promise<ServiceResponse<number>>}
     */
    async getSubscriberCount() {
        const response = await apiService.getData('/api/BroadcastEmail/subscribers/count');
        return response?.data;
    }

    /**
     * Send an email (BCC) to all active subscribers plus any additional email addresses
     * @param subject {string}
     * @param body {string}
     * @param additionalEmails {Array<string>}
     * @returns {Promise<ServiceResponse<number>>}
     */
    async sendToSubscribers(subject, body, additionalEmails = []) {
        const response = await apiService.postData('/api/BroadcastEmail/send', { subject, body, additionalEmails });
        return response?.data;
    }
}